import { TOKEN_KEY } from './constants'
import { getDataFromStorage } from './storageRepository'

export const isUserLogged = () => {
  const token = getDataFromStorage(TOKEN_KEY)
  return !!token
}
